export default function ProbabilityInterviewIco() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33366 3.33341H12.0003C12.3685 3.33341 12.667 3.63189 12.667 4.00008V11.3334L10.445 9.48741C10.3253 9.38795 10.1742 9.33341 10.0185 9.33341H4.66699C4.2988 9.33341 4.00033 9.03495 4.00033 8.66675V6.66675M9.33366 3.33341V1.33341C9.33366 0.965228 9.03519 0.666748 8.66699 0.666748H1.33366C0.965472 0.666748 0.666992 0.965228 0.666992 1.33341V8.66695L2.889 6.82061C3.00869 6.72121 3.15982 6.66675 3.31543 6.66675H4.00033M9.33366 3.33341V6.00008C9.33366 6.36828 9.03519 6.66675 8.66699 6.66675H4.00033"
        stroke="#0070F2"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
